import { Warning } from "@phosphor-icons/react";

export const ConfirmDialog = ({ open, title, body, confirmLabel = "Delete", tone = "delete", busy, onCancel, onConfirm }) => {
  if (!open) return null;
  const isDelete = tone === "delete";
  const btn = tone === "primary"
    ? "bg-foreground text-background border-foreground hover:bg-signal hover:border-signal hover:text-ink"
    : "bg-red-600 text-white border-red-600 hover:bg-red-700";
  return (
    <div className="fixed inset-0 z-50 bg-background/90 flex items-center justify-center p-4" data-testid="admin-confirm-dialog">
      <div className="neu-lg w-full max-w-md p-6 sm:p-8 bg-background">
        <div className={`flex items-center gap-3 ${tone === "primary" ? "text-signal" : "text-red-600 dark:text-red-400"}`}>
          <Warning size={22} weight="bold" />
          <h2 className="text-2xl font-bold text-foreground">{title}</h2>
        </div>
        <p className="mt-4 text-sm text-foreground/80 leading-relaxed" data-testid="admin-confirm-body">{body}</p>
        {isDelete && <p className="mt-2 text-xs text-muted-foreground">This can't be undone.</p>}
        <div className="mt-8 flex justify-end gap-3">
          <button onClick={onCancel} disabled={busy} data-testid="admin-confirm-cancel-btn" className="neu-btn px-5 py-2.5 text-sm">
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={busy}
            data-testid="admin-confirm-delete-btn"
            className={`px-5 py-2.5 text-sm font-bold border disabled:opacity-60 ${btn}`}
          >
            {busy ? (isDelete ? "Deleting…" : "Saving…") : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
